// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__22Mq0","content":"GlobalSearch_content__2k1kW"};